import React from "react";
import { motion } from "framer-motion";
import { useAudio } from "./AudioContext";

export default function GotoCard({
  title,
  text,
  link,
  top,
  left,
  top2,
  left2,
}) {
  const { playAudio, playFlip, pauseFlip, isMobile } = useAudio();

  const handleClick = () => {
    playAudio();
  };

  const handleMouseEnter = () => {
    playFlip(0.6);
  };

  const handleMouseLeave = () => {
    pauseFlip();
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="gotocard"
      style={{ top: isMobile ? top2 : top, left: isMobile ? left2 : left }}
    >
      <a
        href={link}
        onClick={handleClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <h2>{title}</h2>
        <p>{text}</p>
      </a>
    </motion.div>
  );
}
